import React from 'react';
import Queue from '../../../queue/QueueContainer';

const DownloadButton = () => (
  <Queue
    name="reports"
    btnLabel="Export to CSV"
    jobName="cash-register-report"
    label="Cash register report"
  />
);

export default DownloadButton;
